module.exports = __webpack_public_path__ + "assets/img/banner3.2ff2febb.png";